import { FieldAnswer, FieldOption } from "@/src/data/allTypes";
import { formatDate } from "@/src/utils/utils";
import { useState } from "react";
import { Tooltip } from "react-tooltip";

export function AnswersTimelineEvent({
  fieldAnswer,
  onClick,
}: {
  fieldAnswer: FieldAnswer;
  onClick?: () => void;
}) {
  const [isLoading, setIsLoading] = useState(false);
  const { id, status, value, finishedDate, notes } = fieldAnswer;
  function getValue(value: any): any {
    if (Array.isArray(value))
      return value.map((v) => (v?.id?.includes("uploads:") ? v : getValue(v)));
    if (value?.id) return value.id;
    return value;
  }

  function getDisplayableValue(
    value: any,
    options: (FieldOption | null | undefined)[]
  ): any {
    if (Array.isArray(value))
      return value.map((v) => getDisplayableValue(v, options));
    let val = value?.id || value;
    let option = options?.find((option) => option?.id === val);

    let name = option?.name || val;
    if (name == "true") return "oui";
    if (name == "false") return "non";
    return name;
  }

  return (
    <div
      className={`treatmentEvent ${status || ""}  tcenter ${
        isLoading ? "loading" : ""
      }`}
      style={{ borderRadius: "5px" }}
      onClick={async () => {
        setIsLoading(true);
        await onClick?.();
        setIsLoading(false);
      }}
      data-tooltip-id={`tooltipTreatmentEvent${id}`}
      data-tooltip-variant="info"
    >
      <div>
        {getDisplayableValue(
          getValue(fieldAnswer?.value),
          fieldAnswer?.field?.options || []
        )}
        {fieldAnswer?.field?.unit?.name || ""}
      </div>

      <div className="mtop5" style={{ fontWeight: "normal" }}>
        {status == "finished" ? formatDate(finishedDate, "HH:mm") : ""}
      </div>

      {notes != null && notes != "" && notes?.length > 100 && (
        <div className="bold black">Notes*</div>
      )}
      {notes != null && notes != "" && notes?.length < 100 && (
        <div className="bold black">{notes}</div>
      )}

      {notes != null && notes != "" && (
        <Tooltip
          id={`tooltipTreatmentEvent${id}`}
          place="right"
          variant="info"
          content={`${notes || ""}
                    `.trim()}
          positionStrategy="fixed"
          style={{
            zIndex: 9999999999,
            maxWidth: "300px",
            background: "RGBA(255, 255, 255,1)",
            color: "black",
            fontWeight: "normal",
            fontSize: "14px",
            boxShadow: "2px 2px 10px RGBA(0,0,0,0.2)",
            padding: "15px",
            borderRadius: "10px",
          }}
        />
      )}
    </div>
  );
}
